import { Deserializable } from '../protocols/deserializable';
import { MemberAccountFundAllocation } from './member-account-fund-allocation';

export class MemberAccountBalanceByFund implements Deserializable {
  public id!: number;
  public employer!: string;
  public governingJurisdiction!: string | null;
  public totalBalance!: number;
  public fundBalances!: MemberAccountFundAllocation[];

  public onDeserialize(): void {
    if (this.fundBalances?.length) {
      this.fundBalances = window?.injector?.Deserialize?.arrayOf(MemberAccountFundAllocation, this.fundBalances);
    }
  }
}
